import { HttpErrorResponse } from '@angular/common/http';
import type { WishlistRequestError } from '../types/wishlist-request-error.interface';

export function mapWishlistRequestError(error: unknown): WishlistRequestError {
  if (error instanceof HttpErrorResponse) {
    const body: Record<string, unknown> | null = readErrorBody(error.error);
    const message: string | null = readString(body, 'detail') ?? readString(body, 'message');

    return {
      message: message ?? createStatusMessage(error.status),
      statusCode: error.status > 0 ? error.status : null,
      title: readString(body, 'title'),
      type: readString(body, 'type'),
      traceId: readString(body, 'traceId'),
      errorCode: readString(body, 'errorCode'),
    };
  }

  return {
    message: 'Wishlist request failed.',
    statusCode: null,
    title: null,
    type: null,
    traceId: null,
  };
}

function readErrorBody(errorBody: unknown): Record<string, unknown> | null {
  if (typeof errorBody !== 'object' || errorBody === null || Array.isArray(errorBody)) {
    return null;
  }

  return errorBody as Record<string, unknown>;
}

function readString(body: Record<string, unknown> | null, key: string): string | null {
  if (!body) {
    return null;
  }

  const value: unknown = body[key];
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : null;
}

function createStatusMessage(statusCode: number): string {
  return statusCode > 0 ? `Wishlist request failed with status ${statusCode}.` : 'Wishlist request failed.';
}
